var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgEmptySavedreplySearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M12.113 3.094a9.5 9.5 0 0 0 0 19h9.5v-19h-9.5z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeWidth: 1.2,
    d: "M68.385 22.586H12.113c-5.523 0-10-4.477-10-10s4.477-10 10-10h56.272c5.523 0 10 4.477 10 10s-4.477 10-10 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.613 3.086h19v19h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeLinecap: "square",
    strokeWidth: 1.2,
    d: "M21.5 3.5v18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.615 8.81a.475.475 0 0 1 .951.002v8.24a.476.476 0 0 1-.952.001V8.81zm3.427 6.004a.674.674 0 0 1 .687.678v.098a.692.692 0 0 1-1.384 0v-.098a.674.674 0 0 1 .697-.678zm2.64 0a.674.674 0 0 1 .688.678v.098a.693.693 0 0 1-1.384 0v-.098a.67.67 0 0 1 .696-.678zm2.641 0a.674.674 0 0 1 .688.678v.098a.693.693 0 0 1-1.385 0v-.098a.674.674 0 0 1 .697-.678z",
    fill: "#BDBDBD",
    fillRule: "nonzero",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeWidth: 1.2,
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.5 7.5 2 2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M9.84 27.127h21.43a5 5 0 0 1 5 5v29.62c0 2.76-2.24 5-5 5H9.84c-2.76 0-5-2.24-5-5v-29.62a5 5 0 0 1 5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    d: "M10.09 52.969h20.93a1.953 1.953 0 1 1 0 3.906H10.091a1.953 1.953 0 1 1 0-3.906zm0 6.25h20.93a1.953 1.953 0 1 1 0 3.906H10.091a1.953 1.953 0 1 1 0-3.906zM8.442 31.29h24.226v17.851H8.442z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.734,
    height: 25.859,
    x: 0.74,
    y: 0.127,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.937,
    height: 3.906,
    x: 3.584,
    y: 19.328,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    rx: 1.953
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.937,
    height: 3.906,
    x: 20.693,
    y: 19.328,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    rx: 1.953
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M.818 17.063h37.578"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.752,
    height: 3.906,
    x: 3.731,
    y: 4.094,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    rx: 1.953
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.501,
    height: 3.906,
    x: 3.731,
    y: 9.719,
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    rx: 1.953
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeWidth: 1.2,
    d: "M54.571 75.06H21v-9.03C21 60.49 24.82 56 29.531 56h25.04c4.712 0 8.532 4.49 8.532 10.03 0 3.034-1.146 5.454-2.957 7.022-1.495 1.294-3.444 2.008-5.575 2.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M34.006 65a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm5 0a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm5 0a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261zm5 0a1 1 0 0 1 .706.266.902.902 0 0 1 .288.668v.134c-.012.518-.456.932-1 .932s-.988-.414-1-.932v-.134a.901.901 0 0 1 .293-.672.996.996 0 0 1 .713-.261z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmptySavedreplySearch);
export default __webpack_public_path__ + "static/media/img-empty-savedreply-search.62cfb25bd8eac9703e0969ee3ed5ec24.svg";
export { ForwardRef as ReactComponent };